module.exports = __webpack_public_path__ + "img/3.5827ca32.png";